module.exports = __webpack_public_path__ + "static/System-2b9a1ddc5488c0233c81342908c7eec8.jpg";